import { defineComponent } from 'vue'
import store from 'store'
import $store from '@store'
import createApp from '@/utils/createApp'
import App from '@/App'
import { SET_TOKEN, ACCESS_TOKEN, SET_ROUTE_TAB, ROUTE_TABS } from '@store/mutation-types'
import 'ant-design-vue/dist/antd.css';

createApp(
    defineComponent(() => {
        //  在这里读取存储在store里的内容
        $store.commit(`route/${SET_ROUTE_TAB}`, store.get(ROUTE_TABS))
        $store.commit(`user/${SET_TOKEN}`, store.get(ACCESS_TOKEN))
        return () => <App />
    })
).mount('#app')
